import React from "react";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import type { StoriesSummaryProps } from "./storiesSummary.types";

export default function StoriesSummary({ 
  totalStories, 
  totalStoryPoints, 
  totalEpics 
}: StoriesSummaryProps) {
  return (
    <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="bg-indigo-50 rounded-lg p-3">
        <div className="flex items-center space-x-2">
          <BookOpenIcon className="h-4 w-4 text-indigo-600" />
          <span className="text-sm font-medium text-indigo-900">Total Stories</span>
        </div>
        <p className="text-lg font-semibold text-indigo-900 mt-1">
          {totalStories} histórias
        </p>
      </div>
      
      <div className="bg-purple-50 rounded-lg p-3">
        <div className="flex items-center space-x-2">
          <span className="w-4 h-4 bg-purple-600 rounded-full"></span>
          <span className="text-sm font-medium text-purple-900">Story Points</span>
        </div>
        <p className="text-lg font-semibold text-purple-900 mt-1">
          {totalStoryPoints} pontos
        </p>
      </div>
      
      <div className="bg-blue-50 rounded-lg p-3">
        <div className="flex items-center space-x-2">
          <span className="w-4 h-4 bg-blue-600 rounded-full"></span>
          <span className="text-sm font-medium text-blue-900">Épicos</span>
        </div>
        <p className="text-lg font-semibold text-blue-900 mt-1">
          {totalEpics} épicos
        </p>
      </div>
    </div>
  );
}